import useMovement from "../hook/useMovement"
import PendingApprovalMovementTable from "../table/PendingApprovalMovementTable";

const Movement = (
    { dataSource, pagination, onChange, isLoading, onApprove, onReject, }
) => {
    const props = useMovement();
    return <PendingApprovalMovementTable
        {...props}
        dataSource={dataSource}
        onChange={onChange}
        pagination={pagination}
        isLoading={isLoading}
        onApprove={onApprove}
        onReject={onReject}
    />
}
export default Movement